import Client from './Client';

export default class EvaluationClient {
  constructor() {
    this.client = Client;
  }

  /**
   *
   * 行业列表
   */
  async evaluationPage(data) {
    const res = await this.client.post('/api/evaluation/page', data);
    return res;
  }

  /**
   *
   * 行业列表-下拉选择
   *
   */
  async evaluationSelect(data) {
    const res = await this.client.post('/api/evaluation/select', data);
    return res;
  }

  /**
   * 行业列表-新增修改
   *
   */

  async evaluationUpsert(data) {
    const res = await this.client.post('/api/evaluation/upsert', data);
    return res;
  }

  /**
   * 行业列表-修改状态
   *
   */

  async evaluationUpdateValid(data) {
    const res = await this.client.post('/api/evaluation/updateValid', data);
    return res;
  }

  /**
   * 行业列表-获取详情
   *
   */

  async evaluationgetDetail(data) {
    const res = await this.client.post('/api/evaluation/getDetail', data);
    return res;
  }
  /**
   * 行业列表-题目分类-新增修改
   *
   */

  async evaluationCategoryUpsert(data) {
    const res = await this.client.post('/api/evaluation/category/upsert', data);
    return res;
  }
  /**
   * 行业列表-题目分类-列表
   *
   */

  async evaluationCategoryList(data) {
    const res = await this.client.post('/api/evaluation/category/list', data);
    return res;
  }
  /**
   * 行业列表-题目分类-修改状态
   *
   */

  async evaluationCategoryUpdateValid(data) {
    const res = await this.client.post('/api/evaluation/category/updateValid', data);
    return res;
  }
  /**
   * 行业列表-抽奖配置-新增修改
   *
   */

  async evaluationAwardUpsert(data) {
    const res = await this.client.post('/api/evaluation/award/upsert', data);
    return res;
  }
  /**
   * 行业列表-优惠券列表
   *
   */

  async couponList(data) {
    const res = await this.client.post('/api/coupon/select', data);
    return res;
  }
  /**
   * 行业列表-抽奖配置-列表
   *
   */

  async evaluationAwardList(data) {
    const res = await this.client.post('/api/evaluation/award/list', data);
    return res;
  }
  /**
   * 行业列表-抽奖配置
   *
   */

  async evaluationAwardUpdateValid(data) {
    const res = await this.client.post('/api/evaluation/award/updateValid', data);
    return res;
  }

  /**
   * 题库列表-测评宝行业分类选择
   *
   */

  async evaluationAndCategorySelect(data) {
    const res = await this.client.post('/api/evaluation/listEvaluationAndCategorySelect', data);
    return res;
  }
  /**
   * 题库列表-试题列表
   *
   */

  async listPageEvaluation(data) {
    const res = await this.client.post('/api/question/listPageEvaluation', data);
    return res;
  }
  /**
   * 购买记录
   *
   */

  async evaluationOrderPageBackend(data) {
    const res = await this.client.post('/api/evaluation/order/pageBackend', data);
    return res;
  }
  /**
   * 支付金额
   *
   */

  async listSummaryByEvaluationOrderAmount(data) {
    const res = await this.client.post('/api/evaluation/order/listSummaryByEvaluationOrderAmount', data);
    return res;
  }
  /**
   * 购买次数
   *
   */

  async listSummaryByEvaluationOrderCount(data) {
    const res = await this.client.post('/api/evaluation/order/listSummaryByEvaluationOrderCount', data);
    return res;
  }
  /**
   * 机构推荐次数
   *
   */

  async listSummaryByAgencyOrderCount(data) {
    const res = await this.client.post('/api/evaluation/order/listSummaryByAgencyOrderCount', data);
    return res;
  }
}